module.exports = __webpack_public_path__ + "images/cf633efc13a00448950d117799557b79.svg";